import React from 'react';
import { createRoot } from 'react-dom/client';
import MarketApp from './market/app';

const rootElement = document.getElementById('market');
if(rootElement){
    const company_id = rootElement.dataset.companyid
    const league_ids = rootElement.dataset.leagueids
    const athlete_ids = rootElement.dataset.athleteids
    const referral_code = rootElement.dataset.referralcode
    const root = createRoot(rootElement);
    root.render(
        <MarketApp
            company_id={company_id}
            league_ids={league_ids}
            referral_code={referral_code}
            athlete_ids={athlete_ids}
        />
    )
}